import { render, staticRenderFns } from "./AlgorithmDialog.vue?vue&type=template&id=d0383d26&scoped=true"
import script from "./AlgorithmDialog.vue?vue&type=script&lang=js"
export * from "./AlgorithmDialog.vue?vue&type=script&lang=js"
import style0 from "./AlgorithmDialog.vue?vue&type=style&index=0&id=d0383d26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0383d26",
  null
  
)

export default component.exports